module.exports = __webpack_public_path__ + "media/images/common/cart_order_detail-6cbc215857ab49cc42c477c496399644.png";